import styled from "@emotion/styled";

import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const GroupHeader = styled.h3(props => ({
    backgroundColor: theme(props).keyPalette.panelBackgroundColor,
    fontSize: props.theme.candy.typography.header3.fontSize.css(),
    fontWeight: props.theme.candy.typography.header3.fontWeight,
    margin: 0,
}));

export const GroupHeaderContent = styled.div<{ fixed: boolean }>(props => ({
    margin: "0 16px",
    padding: "8px 0 8px 10px",
    boxSizing: "border-box",
    borderBottom: props.fixed ? theme(props).border.solid : "none",
}));

export const GroupHeaderTitle = styled.span<{ noWrap?: boolean }>(props => ({
    marginRight: "0.5em",
    whiteSpace: props.noWrap ? "nowrap" : "normal",
}));

export const GroupHeaderHint = styled.span(props => ({
    color: props.theme.candy.typography.secondary.color,
}));
